import { useMutation } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import axios from 'libs/fetch'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'

type SyncToReglaRes = {
	status: string
}

type SyncToReglaError = {
	code?: string
	detail?: string
	ids?: string[]
}

export const useSyncRentalsToReglaMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: syncRentalsToReglaMutation } = useMutation({
		mutationFn: (ids: number[]) =>
			axiosPrivate.post<SyncToReglaRes>(apiRoutes.rentalsSyncToRegla, { ids }),
		onSuccess: ({ data }) => {
			useToast({
				type: 'success',
				message: data.status
			})()
		},
		onError: (error) => {
			const data = axios.isAxiosError<SyncToReglaError>(error) ? error.response?.data : undefined
			const message = data?.detail || data?.ids?.[0] || t('Something went wrong')

			useToast({
				type: 'error',
				message
			})()
		},
		onSettled
	})

	return {
		syncRentalsToReglaMutation
	}
}
